const mutations = {
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_FULL_NAME: (state, name) => {
    state.full_name = name
  },
  SET_TELEPHONE: (state, telefone) => {
    state.telefone = telefone
  },
  SET_EMAIL: (state, email) => {
    state.email = email
  },
  SET_NATIONAL_NUMBER: (state, nationalNumber) => {
    state.national_number = nationalNumber
  },
  SET_COUNTRY_CODE: (state, countryCode) => {
    state.country_code = countryCode
  },
  SET_POSTCODE: (state, postcode) => {
    state.postcode = postcode
  },
  SET_ADDRESS_CITY: (state, city) => {
    state.address_city = city
  },
  SET_ADDRESS_STREET_NUMBER: (state, number) => {
    state.address_street_number = number
  },
  SET_ADDRESS_STREET_DISTRICT: (state, district) => {
    state.address_street_district = district
  },
  SET_ADDRESS_STREET_COMPLEMENT: (state, complement) => {
    state.address_street_complement = complement
  },
  SET_ADDRESS_STATE: (state, addressState) => {
    state.address_state = addressState
  },
  SET_CUSTOMER: (state, customer) => {
    Object.assign(state, customer)
  },
}

export default mutations
